export default "__VITE_ASSET__5GjDvZSs__"